'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DEFAULT_FOCUS_CLASS = 'modal__default-focus-selector';
var DEFAULT_FOCUS_SELECTOR = ".".concat(DEFAULT_FOCUS_CLASS);

exports.DEFAULT_FOCUS_CLASS = DEFAULT_FOCUS_CLASS;
exports.DEFAULT_FOCUS_SELECTOR = DEFAULT_FOCUS_SELECTOR;
//# sourceMappingURL=constants.js.map
